import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  ALLY_LVL,
  CATEGORY_OPTIONS,
  CATEGORY_OPTIONS_ALLIED,
  COUNTRIES,
  LEVEL_ALLIES,
} from 'src/app/shared/data/data';
import { ConfirmdisableComponent } from '../confirmdisable/confirmdisable.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlliedservicesService } from 'src/app/services/alliedservices.service';
import moment from 'moment';
import { Allied } from 'src/app/shared/data/models';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import 'moment/locale/es';
import { EnableorganizationComponent } from '../enableorganization/enableorganization.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SubSink } from 'subsink';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-allied',
  templateUrl: './edit-allied.component.html',
  styleUrls: ['./edit-allied.component.scss'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-MXN' }],
})
export class EditAlliedComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public alliedLevels = LEVEL_ALLIES;
  public allieCategory = CATEGORY_OPTIONS_ALLIED;
  public typesOptionsOrganization = CATEGORY_OPTIONS;
  public levelSelected: number | null = null;
  public countrySelected: number | null = null;
  public levelValue: string | undefined = undefined;
  public hideRequiredControl = new FormControl(true);
  public alliedEdited: Allied;
  public allied: any = this.data.organizacionData;
  public statusAllied: boolean = true;
  private alliedLvl: any = ALLY_LVL;
  private countries: any = COUNTRIES;

  public alliedForm: FormGroup = this.fb.group({
    hideRequired: this.hideRequiredControl,
    name_ally: ['', [Validators.required]],
    category: ['', [Validators.required]],
    country: ['', [Validators.required]],
    start_date: ['', [Validators.required]],
    ending_date: ['', [Validators.required]],
    ally_level: ['', [Validators.required]],
    status: [true, []],
  });

  public minDate: Date;

  constructor(
    private fb: FormBuilder,
    private alliedService: AlliedservicesService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; organizacionData: any; status: boolean },
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private _snackBar: MatSnackBar,
    private trasnlateService: TranslateService,
    private router: Router
  ) {
    const today = new Date();

    if (
      this.transformDate(data.organizacionData.start_date).getTime() >
      today.getTime()
    ) {
      this.minDate = today;
    } else {
      this.minDate = this.transformDate(data.organizacionData.start_date);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this._locale = 'es';
    this._adapter.setLocale(this._locale);
    this.chargeData(this.data.organizacionData);
  }

  public getLevleAllied(id: number): void {
    this.levelSelected = id;
    this.alliedForm.controls['ally_level'].setValue(LEVEL_ALLIES[id].level);
  }

  public chooseCountry(id: number): void {
    this.countrySelected = id;
    this.alliedForm.controls['country'].setValue(
      CATEGORY_OPTIONS_ALLIED[id].option2
    );
  }

  private chargeData(profile: any): void {
    this.countrySelected = this.countries[profile.country];
    this.levelSelected = this.alliedLvl[profile.ally_level];
    this.alliedForm.patchValue({
      hideRequired: '',
      name_ally: profile.name_ally,
      category: profile.category,
      country: profile.country,
      start_date: this.transformDate(profile.start_date),
      ending_date: this.transformDate(profile.ending_date),
      ally_level: profile.ally_level,
      status: true,
    });
  }

  private editionAllied(id: string, data: any): void {
    this.subs.sink = this.alliedService.editAllied(id, data).subscribe();
  }

  private transformDate(fecha: string): Date {
    let dateType: Date = new Date();
    let dateFormat = fecha.split('-');
    let year = dateFormat[0];
    let month = dateFormat[1];
    let day = dateFormat[2];
    dateType = new Date(`${year}/${month}/${day}`);
    return dateType;
  }

  public sendData(form: FormGroup): void {
    if (form.invalid) {
      this.markFormError(form);
    } else {
      const alliedEdited = {
        ...this.alliedForm.value,
        start_date: this.getData(form.get('start_date')?.value),
        ending_date: this.getData(form.get('ending_date')?.value),
      };
      this.changesMade(this.allied._id, alliedEdited);
      this.closeForm();
    }
  }

  private markFormError(editOrgForm: FormGroup): void {
    return Object.values(editOrgForm.controls).forEach((control) => {
      control.markAllAsTouched();
    });
  }

  public closeForm(): void {
    this.dialog.closeAll();
    this.alliedForm.reset();
  }

  public confirmDisabled(): void {
    const dialogref = this.dialog.open(ConfirmdisableComponent, {
      width: '456px',
      height: '208px',
      disableClose: true,
      data: {
        title: this.allied.name_ally,
        statusAllied: this.allied.status,
      },
    });

    this.subs.sink = dialogref.afterClosed().subscribe((result: boolean) => {
      if (result == false) {
        this.disableStatus(result);
      }
      this.dialog.closeAll();
    });
  }

  private getData(dataDate: any): string {
    return moment(dataDate).format('YYYY-MM-DD');
  }

  public activeAllied(): void {
    const dialogref = this.dialog.open(EnableorganizationComponent, {
      width: '456px',
      height: '208px',
      disableClose: true,
      data: {
        title: this.allied.name_ally,
        statusAllied: this.allied.status,
      },
    });
    this.subs.sink = dialogref.afterClosed().subscribe((result: boolean) => {
      if (result == true) {
        this.editStatusOrganizaton(result);
      }
      this.dialog.closeAll();
    });
  }

  private editStatusOrganizaton(result: boolean): void {
    let change = true;
    this.subs.sink = this.trasnlateService
      .get(['USERS.toast-succes1', 'USERS.undo'])
      .subscribe((valor) => {
        const message = valor['USERS.toast-succes1'];
        const action = valor['USERS.undo'];
        const snackBarRef = this._snackBar.open(message, action, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
        snackBarRef.onAction().subscribe(() => {
          change = false;
        });
        snackBarRef.afterDismissed().subscribe(() => {
          if (result == true) {
            const modifiedOrg = {
              ...this.alliedEdited,
              disabled: result,
            };
            this.editionAllied(this.allied._id, modifiedOrg);
            this.goToOrganizationsList();
          }
        });
      });
  }

  private disableStatus(result: boolean): void {
    let change = true;
    this.subs.sink = this.trasnlateService
      .get(['USERS.toast-succes2', 'USERS.undo'])
      .subscribe((valor) => {
        const message = valor['USERS.toast-succes2'];
        const action = valor['USERS.undo'];
        const snackBarRef = this._snackBar.open(message, action, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
        snackBarRef.onAction().subscribe(() => {
          change = false;
        });
        snackBarRef.afterDismissed().subscribe(() => {
          if (change === true) {
          }
          if (result == false) {
            const modifiedOrg = {
              ...this.alliedEdited,
              disabled: result,
            };
            this.editionAllied(this.allied._id, modifiedOrg);
            this.goToOrganizationsList();
          }
        });
      });
  }

  private changesMade(id: string, allied: any): void {
    let change = true;
    this.subs.sink = this.trasnlateService
      .get(['FACILITATOR.changes-sucess', 'USERS.undo'])
      .subscribe((valor) => {
        const message = valor['FACILITATOR.changes-sucess'];
        const action = valor['USERS.undo'];
        const snackBarRef = this._snackBar.open(message, action, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
        snackBarRef.onAction().subscribe(() => {
          change = false;
        });
        snackBarRef.afterDismissed().subscribe(() => {
          if (change === true) {
            this.editionAllied(id, allied);
            this.goToOrganizationsList();
          }
        });
      });
  }

  private goToOrganizationsList(): void {
    this.router.navigate(['/pages/userdash', 'id'], {
      queryParams: { tab: 1 },
    });
  }

  private returnDate(value: string): Date {
    let timDateValue = value.split('/').reverse().join('/');
    return new Date(timDateValue);
  }

  public getValueDate(date: string): void {
    this.alliedForm.controls['start_date'].setValue(this.returnDate(date));
  }
  public getValueFinal(date: string): void {
    this.alliedForm.controls['ending_date'].setValue(this.returnDate(date));
  }
}
